export const ProjectName = {
  projectName: "Cervino"
}